import { ComplianceLimitService } from "@/common/api.service";
import { FETCH_COMPLIANCE_LIMITS } from "./actions.type";
import { FETCH_COMPLIANCE_LIMITS_END } from "./mutations.type";

const state = {
  complianceLimits: {},
  isLoading: true
};

const getters = {
  complianceLimits(state) {
    return state.complianceLimits;
  }
};

const actions = {
  async [FETCH_COMPLIANCE_LIMITS]({ commit }) {
    return ComplianceLimitService.get()
      .then(({ data }) => {
        commit(FETCH_COMPLIANCE_LIMITS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_COMPLIANCE_LIMITS_END](state, complianceLimits) {
    state.complianceLimits = complianceLimits;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
